/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react";
import axios from 'axios';
import { FirstDayForMonth,LastDayForMonth,getDaysInThisMonth,ChangeSearchingDateFormat } from "../../components/common/Common";

const SetupCalendar = ({ varCurrentMonth,varCurrentDate,onSelectDateHandler }) => {
  const mem_idx = localStorage.getItem('mem_idx');

  const [varDailyCounter,setDailyCounter] = useState([]);

  //배송일자
  const GetDailyDelivery = async(monthArray) => {
    const cdate = ChangeSearchingDateFormat(varCurrentMonth,'-');
    const sendData = {mem_idx:mem_idx,dc_riding_date:cdate};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_delivery_daily_counter`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const dailyData = datas.results;
        console.log(monthArray.length);
        for(var i=0; i < monthArray.length; i++) {
          for(var j=0; j < 7; j++) {
            if(monthArray[i][j].date !== "") {
              for(var k=0; k < dailyData.length; k++) {
                if(Number(monthArray[i][j].date) === Number(dailyData[k].sday)) {
                  if(Number(dailyData[k].dcount > 0))
                    monthArray[i][j].count = dailyData[k].dcount;
                }
              }
            }
          }
        }
        console.log(monthArray);
        setDailyCounter(monthArray);
      }
    });
  }

  //검색날짜가 변경시
  useEffect(() => {
    //console.log(varCurrentMonth);
    //해당월의 1일과 마지막일자
    const firstDay = FirstDayForMonth(varCurrentMonth);
    const lastDay = LastDayForMonth(varCurrentMonth);
    //console.log(firstDay);

    const iWeekS = firstDay.getDay(); //0:일요일,1:월요일
    const iWeekE = lastDay.getDay(); //0:일요일,1:월요일
    console.log(iWeekS,iWeekE);
    const monthArray = [];
    
    let iline = -1;
    let iweek = -1;
    if(iWeekS > 0) {
      iline++;
      monthArray[iline] = [];
      for(var i=0; i < iWeekS; i++) {
        iweek++;
        const dayObj = {date:'',count:''};
        monthArray[iline].push(dayObj);
      }
    }
    const mdays = getDaysInThisMonth(varCurrentMonth);
    for(var j=0; j < mdays; j++) {
      iweek++;
      if(iweek%7 === 0){
        iline++;
        monthArray[iline] = [];
      } 
      const dayObj = {date:j+1,count:''};
      monthArray[iline].push(dayObj);
    }
    const stnum = iWeekE + 1;
    for(var k=stnum; k < 7; k++) {
      const dayObj = {date:'',count:''};
      monthArray[iline].push(dayObj);
    }
    console.log(monthArray);
    GetDailyDelivery(monthArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varCurrentMonth]);

  console.log(varCurrentDate.getDate());

  return (
    <table className="driving-calendar-table mb30">
      <thead>
        <tr><th>일</th><th>월</th><th>화</th><th>수</th><th>목</th><th>금</th><th>토</th></tr>
      </thead>
      <tbody>
        {varDailyCounter.map((nweeks,i)=>(
          <tr key={'nweeks_'+i}>
            {nweeks.map((days,j)=>(
              <td key={'days_'+j} onClick={days.date===""?null:e=>onSelectDateHandler(e,days.date)}>
                {days.date===""?null
                :days.count===""?<span className={Number(varCurrentDate.getDate())===Number(days.date)?"selected":""}>{days.date}</span>
                :<><span className={Number(varCurrentDate.getDate())===Number(days.date)?"selected":""}>{days.date}</span><span className="calendar-tag">+{days.count}</span></>}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
export default SetupCalendar;